import logo from "../assets/images/Logo Coded-Estate.svg";
import arrow_swap from "../assets/images/Header/arrow-swap.svg";
import notification_bing from "../assets/images/Header/notification-bing.svg";
import light from "../assets/images/Header/light.svg";
import arrowToDown from "../assets/images/Header/Arrow.svg";
import nusd from "../assets/images/Frame.svg";
import arrow_left from "../assets/images/arrowToleft.svg";
import usdt_svg from "../assets/images/USDT.svg";
// import eth_svg from "../assets/images/ETH.svg";
import fdusd_icon from "../assets/images/FDUSD.svg";
import dai_svg from "../assets/images/dai.svg";
import check_mark from "../assets/images/Checkmark.svg";

export const NibiruIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2615_6459)">
        <g clip-path="url(#clip1_2615_6459)">
          <path d="M22 0H0V22H22V0Z" fill="url(#paint0_linear_2615_6459)" />
          <path
            d="M11.1669 4.14359L11.4358 3.76121L11.1669 3.57202L10.8979 3.76121L11.1669 4.14359ZM6.98921 7.08218L6.72023 6.69978L6.1855 7.07593L6.71434 7.46032L6.98921 7.08218ZM15.3445 7.08218H15.812V6.83943L15.6135 6.69978L15.3445 7.08218ZM15.3445 13.1552L15.0697 13.5334L15.812 14.073V13.1552H15.3445ZM14.973 14.9184L15.2469 15.2973L15.7695 14.9195L15.2479 14.5403L14.973 14.9184ZM6.61789 8.84539L6.89276 8.46721L6.15039 7.9276V8.84539H6.61789ZM10.9083 17.857L10.6442 18.2427L10.9156 18.4286L11.1822 18.2359L10.9083 17.857ZM6.61789 14.9184H6.15039V15.1649L6.35371 15.3042L6.61789 14.9184ZM10.8979 3.76121L6.72023 6.69978L7.25818 7.46454L11.4358 4.52596L10.8979 3.76121ZM15.6135 6.69978L11.4358 3.76121L10.8979 4.52596L15.0756 7.46454L15.6135 6.69978ZM15.812 13.1552V7.08218H14.877V13.1552H15.812ZM6.71434 7.46032L15.0697 13.5334L15.6194 12.7771L7.26407 6.704L6.71434 7.46032ZM15.2479 14.5403L6.89276 8.46721L6.34302 9.22353L14.6981 15.2966L15.2479 14.5403ZM11.1822 18.2359L15.2469 15.2973L14.6991 14.5396L10.6344 17.4781L11.1822 18.2359ZM6.35371 15.3042L10.6442 18.2427L11.1725 17.4713L6.88207 14.5327L6.35371 15.3042ZM6.15039 8.84539V14.9184H7.08539V8.84539H6.15039Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2615_6459"
          x1="-2.0324"
          y1="-2.36912"
          x2="23.0476"
          y2="-1.02899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F29AC4" />
          <stop offset="0.13" stop-color="#F2A9CB" />
          <stop offset="0.275" stop-color="#F2BAD5" />
          <stop offset="0.395" stop-color="#CDC6D7" />
          <stop offset="0.52" stop-color="#82D1D9" />
          <stop offset="0.66" stop-color="#09D4D7" />
          <stop offset="0.8" stop-color="#11BBCA" />
          <stop offset="1" stop-color="#17A0BF" />
        </linearGradient>
        <clipPath id="clip0_2615_6459">
          <rect width="22" height="22" rx="11" fill="white" />
        </clipPath>
        <clipPath id="clip1_2615_6459">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CheckMarkIcon = ({ className }) => {
  return <img alt="" src={check_mark} className={className} />;
};

export const ArrowToLeft = ({ className }) => {
  return <img alt="" src={arrow_left} className={className} />;
};

export const NUSDIcon = ({ className }) => {
  return <img alt="" src={nusd} className={className} />;
};

export const FDUSDIcon = ({ className }) => {
  return <img alt="" src={fdusd_icon} className={className} />;
};

export const USDTIcon = ({ className }) => {
  return <img alt="" src={usdt_svg} className={className} />;
};

// export const EthIcon = ({ className }) => {
//   return <img alt="" src={eth_svg} className={className} />;
// };

export const DAIIcon = ({ className }) => {
  return <img alt="" src={dai_svg} className={className} />;
};

export const Logo = ({ className, onClick }) => {
  return <img alt="" src={logo} onClick={onClick} className={className} />;
};

export const SwapIconHeader = ({ className }) => {
  return <img alt="" src={arrow_swap} className={className} />;
};

export const NotificationBingIconHeader = ({ className }) => {
  return <img alt="" src={notification_bing} className={className} />;
};

export const LightIcon = ({ className }) => {
  return <img alt="" src={light} className={className} />;
};

export const ArrowToDownHeader = ({ className }) => {
  return <img alt="" src={arrowToDown} className={className} />;
};
